import { Route, Navigate } from "react-router-dom";
import DashboardLayout from "@/components/DashboardLayout";
import AdminRoute from "./AdminRoute";

import AdminDashboard from "@/pages/admin/Dashboard";
import AdminUsers from "@/pages/admin/Users";
import AdminMemberships from "@/pages/admin/Memberships";
import AdminVendors from "@/pages/admin/Vendors";
import AdminProducts from "@/pages/admin/Products";
import AdminDealDetail from "@/pages/admin/DealDetail";
import AdminGroupDetail from "@/pages/admin/GroupDetail";
import AdminApplications from "@/pages/admin/Applications";
import AdminTransactions from "@/pages/admin/Transactions";
import AdminPromoCodes from "@/pages/admin/PromoCodes";
import AdminStripeProducts from "@/pages/admin/StripeProducts";
import AdminStripeDiscounts from "@/pages/admin/StripeDiscounts";
import AdminAffiliateApplications from "@/pages/admin/AffiliateApplications";
import AdminAffiliatePayouts from "@/pages/admin/AffiliatePayouts";
import AdminUserDetail from "@/pages/admin/UserDetail";
import DataTables from "./DataTables";
import AdminCrudPage from "./AdminCrudPage";
import AdminCountries from "@/pages/admin/Countries";
import AdminSuspiciousCheckouts from "@/pages/admin/SuspiciousCheckouts";

/**
 * Returns the admin `<Route>` block ready to be spread inside <Routes>.
 * All admin routes are gated by <AdminRoute> and rendered inside the shared
 * dashboard layout. Landing at /admin sends the user to the dashboard.
 */
export function buildAdminRoutes() {
    return (
        <Route element={<AdminRoute />}>
            <Route element={<DashboardLayout />}>
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/admin/users" element={<AdminUsers />} />
                <Route path="/admin/users/:userId" element={<AdminUserDetail />} />
                <Route path="/admin/memberships" element={<AdminMemberships />} />
                <Route path="/admin/vendors" element={<AdminVendors />} />
                <Route path="/admin/products" element={<AdminProducts />} />
                <Route path="/admin/products/deals/:dealId" element={<AdminDealDetail />} />
                <Route path="/admin/products/groups/:groupId" element={<AdminGroupDetail />} />
                <Route path="/admin/applications" element={<AdminApplications />} />
                <Route path="/admin/transactions" element={<AdminTransactions />} />
                <Route path="/admin/promo-codes" element={<AdminPromoCodes />} />
                <Route path="/admin/stripe-products" element={<AdminStripeProducts />} />
                <Route path="/admin/stripe-discounts" element={<AdminStripeDiscounts />} />
                <Route path="/admin/affiliate-applications" element={<AdminAffiliateApplications />} />
                <Route path="/admin/affiliate-payouts" element={<AdminAffiliatePayouts />} />
                <Route path="/admin/data" element={<DataTables />} />
                <Route path="/admin/data/:route" element={<AdminCrudPage />} />
                <Route path="/admin/countries" element={<AdminCountries />} />
                <Route path="/admin/suspicious-checkouts" element={<AdminSuspiciousCheckouts />} />
                <Route path="/admin/*" element={<Navigate to="/admin" replace />} />
            </Route>
        </Route>
    );
}
